// extracted by mini-css-extract-plugin
module.exports = {"TilesGallery":"TilesGallery_TilesGallery__pvGzO","image":"TilesGallery_image__6wiqq"};